

export const fakeId = (id: number) => {
    return id * 17 + 1000;
}